import { IQuery, IQueryMediator } from 'core-ts-types';

import * as _4 from 'lodash4';
import { RegistrationPinsModel } from '../../../models/registration_pins_model';
export class RegistrationPinsQuery implements IQuery {
  private _result: {
    disableDropAction: boolean;
    disableRegisterAction: boolean;
  };

  constructor(QueryMediator: IQueryMediator, private ngRegistrationPinsModel: RegistrationPinsModel) {
    QueryMediator.registerQuery(this, this.ngRegistrationPinsModel);
  }
  shouldDropActionAllowed() {
    const allSections = this.ngRegistrationPinsModel.read()._registration_pins_sections;
    return _4.some(_4.filter(allSections, { status: 'REGISTERED' }), 'is_selected');
  }
  shouldRegisterActionAllowed() {
    const allSections = this.ngRegistrationPinsModel.read()._registration_pins_sections;
    return _4.some(_4.filter(allSections, { status: 'SECTION_PICKED' }), 'is_selected');
  }

  run() {
    const disableDropAction = !this.shouldDropActionAllowed();
    const disableRegisterAction = !this.shouldRegisterActionAllowed();

    this._result = {
      disableDropAction,
      disableRegisterAction
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationPinsQuery', RegistrationPinsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pins/queries/registration_pins_query.ts